enum EUserContextMessagesKey {
	logout = 'logout',
	login = 'login'
}

enum EUserAction {
	INIT_USER_STATISTICS = 'INIT_USER_STATISTICS',
	UPDATE_USER_STATISTICS = 'UPDATE_USER_STATISTICS',
	FINISH_QUEST = 'FINISH_QUEST',
	FINISH_CAMPAIGN = 'FINISH_CAMPAIGN',
	FINISH_CAMPAIGN_BY_SLUG = 'FINISH_CAMPAIGN_BY_SLUG',
	RESET_STATE = 'RESET_STATE',
	ADD_NEW_QUEST = 'ADD_NEW_QUEST',
	ADD_NEW_CAMPAIGN = 'ADD_NEW_CAMPAIGN',
	ADD_QUEST_AND_CAMPAING = 'ADD_QUEST_AND_CAMPAING'
}

enum EGithubAppState {
	notInstalled = 'NOT_INSTALLED',
	missingRepo = 'MISSING_NG_QUESTPLAY',
	ok = 'OK',
	unset = 'UNSET'
}

export { EGithubAppState, EUserAction, EUserContextMessagesKey };
